<template>
    <div class="ms-2">
        <div class="ms-2">
            <div class="dropdown">
                <button class="btn btn-light btn-sm dropdown-toggle" type="button" id="viewOptionsDropdown"
                        data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <i class="fas fa-ellipsis-h"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="viewOptionsDropdown">

                    <h6 class="dropdown-header">View</h6>

                    <div @click="onEditClick" class="pointer dropdown-item">
                        <i class="fal fa-pencil text-secondary me-1 menu-icon"></i>
                        <a class="no-underline menu-link" href="javascript:void(0)">Edit</a>
                    </div>

                    <div v-if="table.views.length > 1" @click="onDeleteClick" class="pointer dropdown-item">
                        <i class="fal fa-trash-alt text-secondary me-1 menu-icon"></i>
                        <a class="no-underline menu-link" href="javascript:void(0)">Delete</a>
                    </div>

                    <div v-if="customizable" @click="onCustomizeClick" class="pointer dropdown-item">
                        <i class="fal fa-paint-brush-alt text-secondary me-1 menu-icon"></i>
                        <a class="no-underline menu-link" href="javascript:void(0)">Customize</a>
                    </div>

                    <div v-if="view.published" class="pointer dropdown-item">
                        <i class="fal fa-external-link text-secondary me-1 menu-icon"></i>
                        <a class="no-underline menu-link" :href="publicLink" target="_blank">Open Public View</a>
                    </div>

                    <div class="dropdown-divider"></div>

                    <h6 class="dropdown-header">Table</h6>

                    <div @click="showTableModal = true" class="pointer dropdown-item">
                        <i class="fal fa-pencil text-secondary me-1 menu-icon"></i>
                        <a class="no-underline menu-link" href="javascript:void(0)">Edit</a>
                    </div>

                    <div @click="onNewFieldClick" class="pointer dropdown-item">
                        <i class="fal fa-plus text-secondary me-1 menu-icon"></i>
                        <a class="no-underline menu-link" href="javascript:void(0)">New Field</a>
                    </div>

                </div>
            </div>
        </div>

        <confirm-modal :key="'confirm-modal-on-' + view.id"
                       v-if="showConfirmDeleteModal"
                       @noEvent="showConfirmDeleteModal = false"
                       :yesEvent="deleteView"
                       text="Are you sure you want to delete this view?">
        </confirm-modal>

        <view-modal :key="'view-on-' + table.id" v-if="showViewEditor" :table="table"
                    :view="view" @noEvent="showViewEditor = false"></view-modal>

        <field-modal :key="'fields-on-' + table.id" v-if="showFieldEditor" :table="table"
                     :field="currentField" @noEvent="showFieldEditor = false"></field-modal>

        <table-modal v-if="showTableModal" @noEvent="showTableModal = false" :table="table"></table-modal>
    </div>
</template>

<script>

    import OnOffControl from "../../components/OnOffControl.vue";
    import ViewService from "../../services/ViewService";
    import ViewModal from "../../editor/app/ViewModal.vue";
    import ConfirmModal from "../../components/ConfirmModal.vue";
    import FieldModal from "../../editor/app/FieldModal.vue";
    import TableModal from "../../components/TableModal.vue";

    export default {
        name: 'ViewOptionsDropdown',
        components: {TableModal, FieldModal, ConfirmModal, ViewModal, OnOffControl},
        props: ['view', 'table'],
        computed: {
            customizable() {
                return this.view.view_type === 'list' || this.view.view_type === 'form' ||
                    this.view.view_type === 'custom' || this.view.view_type === 'gallery' ||
                    this.view.view_type === 'details'
            },
            publicLink() {
                return '/' + this.view.id
            }
        },
        data() {
            return {
                model: webase.model,
                showViewEditor: false,
                showConfirmDeleteModal: false,
                deleteView: function () {
                },
                currentField: {
                    name: '',
                    field_type: 'String',
                    model_id: '',
                    metadata: '',
                    required: false,
                    id: null
                },
                showFieldEditor: false,
                showTableModal: false
            }
        },
        methods: {
            onNewClick() {
                this.currentView = {
                    name: '',
                    view_type: 'list',
                    model_id: this.table.id,
                    published: false,
                    group_field_id: null,
                    layout: {
                        description: ''
                    },
                    id: null
                }

                this.showViewEditor = true
            },
            onEditClick() {
                this.showViewEditor = true
            },
            onCustomizeClick() {
                console.log('onCustomizeClick')
                console.log(this.view)
                // if(this.view.view_type === 'gallery') {
                //     this.$router.push({name: 'exp-layout-editor', params: {id: this.view.id}})
                // }
                // else {
                     this.$router.push({name: 'view-editor', params: {id: this.view.id}})
                // }
            },
            onDeleteClick() {
                let viewService = new ViewService()
                this.showConfirmDeleteModal = true

                this.deleteView = () => {
                    viewService.remove(this.view.id).then(() => {
                        webase.utils.array.remove(this.table.views, this.view.id)
                        this.showConfirmModal = false

                        let nextView = this.table.views[0]
                        this.$router.push({name: 'view-renderer', params: {id: nextView.id}})
                    }).catch((error) => {
                        console.log('Error removing view.')
                        console.log(error)
                        this.showConfirmModal = false
                    })
                }

            },
            onNewFieldClick() {
                this.currentField = {
                    name: '',
                    field_type: 'String',
                    model_id: this.table.id,
                    child_model_id: null,
                    required: false,
                    id: null
                }

                this.showFieldEditor = true
            }
        }
    }
</script>

